import React from 'react';
import useInputOptionsTheme from './themes';
import { IOptionProps } from './_props';
import { TFormField } from '../../utils/types';
import SearchInput from './_SearchInput';
import Item from './Item';
import VList from '../../../../VirtualizedList';

function MultiselectOptions<TFormFields extends TFormField = TFormField>({
  highlightOptions,
  maxLength,
  name,
  labelPosition,
  placeholder,
  onKeyDown,
  register,
  rules,
  getInputProps,
  getItemProps,
  getMenuProps,
  highlightedIndex,
  isOpen,
  getLabelProps,
  inputValue,
  selectedItems,
  getDropdownProps,
  items,
}: IOptionProps<TFormFields>) {
  const {
    optionsWrapperThemeClasses,
    optionThemeClasses,
    optionActiveThemeClasses,
    optionSelectedThemeClasses,
    optionIconThemeClasses,
    optionHighlightedTextThemeClasses,
  } = useInputOptionsTheme();

  const { htmlFor } = getLabelProps();

  const highlightIndexes =
    highlightOptions && inputValue
      ? items.map((opt) => opt.label.toLowerCase().indexOf(inputValue.toLowerCase()))
      : [];

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    <ul
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      {...getMenuProps()}
    >
      {isOpen && (
        <div className={optionsWrapperThemeClasses}>
          <SearchInput
            htmlFor={htmlFor}
            getLabelProps={getLabelProps}
            maxLength={maxLength}
            name={name}
            labelPosition={labelPosition}
            placeholder={placeholder}
            getInputProps={getInputProps}
            getDropdownProps={getDropdownProps}
            isOpen={isOpen}
            onKeyDown={onKeyDown}
            register={register}
            rules={rules}
          />
          <div className="">
            <VList
              containerHeight={150}
              containerWidth="100%"
              eachItemSize={48}
              totalItemsCount={items.length}
              paintedItemsAfterOverflow={5}
            >
              {({ index, style }) => (
                <Item
                  key={items[index].value}
                  option={items[index]}
                  index={index}
                  getItemProps={getItemProps}
                  highlightedIndex={highlightedIndex}
                  selectedItems={selectedItems}
                  inputValue={inputValue}
                  highlightOptions={highlightOptions}
                  highlightIndexes={highlightIndexes}
                  optionThemeClasses={optionThemeClasses}
                  optionActiveThemeClasses={optionActiveThemeClasses}
                  optionSelectedThemeClasses={optionSelectedThemeClasses}
                  optionHighlightedTextThemeClasses={optionHighlightedTextThemeClasses}
                  optionIconThemeClasses={optionIconThemeClasses}
                  style={style}
                />
              )}
            </VList>
          </div>
        </div>
      )}
    </ul>
  );
}

export default MultiselectOptions;
